import React from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

interface ListItemLinkProps {
  icon?: React.ReactElement;
  primary: string;
  to: string;
  handleClick: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    selection: {
      "&:hover, &:active": {
        background: "transparent",
      },
    },
    icon: {
      '& svg': {
        width: '16.5px',
      },
      margin: "0px",
    },
    label: {
    },
  })
);

export default function ListItemLink(props: ListItemLinkProps) {
  const { icon, primary } = props;
  const linkClasses = useStyles();
  
  return (
    <li>
      <ListItem button
                className={linkClasses.selection}
                // component={renderLink}
                onClick={props.handleClick}
      >
        {icon ? (
          <ListItemIcon className={linkClasses.icon}>{icon}</ListItemIcon>
        ) : null}
        <ListItemText className={linkClasses.label} primary={primary} />
      </ListItem>
    </li>
  );
}
